import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"

const AddVendorLoan = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vendors, setVendors] = useState([])

  const a = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []
  useEffect(() => {
    const load = async () => {
      try {
        const [co, pl, cc] = await Promise.all([api.get("companies"), api.get("plants"), api.get("centers")])
        setCompanies(a(co)); const p = a(pl); setAllPlants(p); setPlants(p); const c = a(cc); setAllCenters(c); setCenters(c)
      } catch (e) { console.error(e) }
    }; load()
  }, [])

  const showCompany = companies.length > 1
  const companyChange = async v => { setCenters(allCenters); setRoutes([]); setVendors([]); if (v) { try { setPlants(a(await api.get("plants-by-company/" + v))) } catch (e) {} } else setPlants(allPlants) }
  const plantChange = async v => { setRoutes([]); setVendors([]); if (v) { try { setCenters(a(await api.get("chillings-by-plant/" + v))) } catch (e) {} } else setCenters(allCenters) }
  const ccChange = async v => { setVendors([]); if (v) { try { setRoutes(a(await api.get("route-cc/" + v))) } catch (e) {} } else setRoutes([]) }
  const routeChange = async v => { if (v) { try { setVendors(a(await api.get("vendors"))) } catch (e) {} } else setVendors([]) }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      if (companies.length === 1) values.company = companies[0].id
      const response = await api.post("create-vendor-loan", values)
      if (response.data.success === true) {
        formRef.current.reset(); setSubmitted(true); setRoutes([]); setVendors([])
        setTimeout(() => setSubmitted(false), 3000)
      }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Vendor Loan</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}><Link to="/vendor-loans" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal" onValidSubmit={handleValidSubmit}>
          {showCompany && <Row><Col md={6}><div className="mb-3">
            <AvField type="select" name="company" label="Company *" required onChange={e => companyChange(e.target.value)}>
              <option value="">Select Company</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
            </AvField></div></Col></Row>}
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="plant" label="Plant" onChange={e => plantChange(e.target.value)}>
              <option value="">All Plants</option>{plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center *" required onChange={e => ccChange(e.target.value)}>
              <option value="">Select Chilling Center</option>{centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route *" required onChange={e => routeChange(e.target.value)}>
              <option value="">Select Route</option>{routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="bulkVendor" label="Vendor *" required>
              <option value="">Select Vendor</option>{vendors.map((v, i) => <option key={i} value={v.id}>{v.vendorName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="loanDate" label="Loan Date *" type="date" required /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="loanAmount" label="Loan Amount *" type="text" required
              validate={{ pattern: { value: /^[0-9,]+(\.[0-9]{1,2})?$/, errorMessage: "Enter a valid amount" } }} /></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="deductionAmount" label="Deduction Amount Per Bill *" type="text" required
              validate={{ pattern: { value: /^[0-9,]+(\.[0-9]{1,2})?$/, errorMessage: "Enter a valid amount" } }} /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" /></div></Col>
          </Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Vendor Loan Added!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /> Adding...</> : "Add Loan"}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default AddVendorLoan
